import React, {useState, useEffect} from 'react';
import './News.css';
import NewsHeader from './NewsHeader';
import NewsEntry from './NewsEntry';
import ImageUpload from './ImageUpload';
import {useSelector} from 'react-redux';
import {selectUser} from './features/userSlice';
import {selectNewsId, selectNewsName} from './features/newsSlice';
import { db, storage } from './firebase';
import firebase from 'firebase';
import AddIcon from '@material-ui/icons/Add';


function News() {
    const user = useSelector(selectUser);
    const newsId = useSelector(selectNewsId);
    const newsName = useSelector(selectNewsName);
    const [input, setInput] = useState("");
    const [newsEntry, setNewsEntry] = useState([]);
    

    useEffect (() => {
        if (newsId) {
        db.collection("news")
            .doc(newsId)
            .collection("newsEntry")
            .orderBy('timestamp', 'asc')
            .onSnapshot((snapshot) =>
                setNewsEntry(
                snapshot.docs.map((doc) =>
                    doc.data()))
                );
                }
        },[newsId]);

        const sendNews = (e) => {
            e.preventDefault();
        
            db.collection("news")
                .doc(newsId)
                .collection('newsEntry').add({
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    newsEntry: input,
                    user: user,
                    photoUrl: user.photoUrl || "",
                });
            setInput("");
        }

        const handleAddNews = () => {
            const newsName = prompt("Enter a News Title");
            
            if(newsName) {
                db.collection("news").add({
                    newsName: newsName,
                });
            }
            };
    return (
        <div className="news">
                <NewsHeader newsName={newsName}/>

            <div className="news__messages">
            {newsEntry.map((newsEntry) => (
                <NewsEntry
                timestamp={newsEntry.timestamp}
                newsEntry={newsEntry.newsEntry}
                user={newsEntry.user}
                caption={newsEntry.caption}
                imageUrl={newsEntry.imageUrl}
                photoUrl={newsEntry.photoUrl}
                /> 
            ))}
            </div>

            <div className="news__input">
                <form>
                    <div className="news__inputAdd">
                        <h4>{`Add Article's Title (just for New Articles!)`}</h4>
                        <AddIcon onClick={handleAddNews}
                        className="news__inputAddIcon"/>           
                    </div>
                    <ImageUpload username={user.displayName}/>
                    <input 
                    disabled={!newsId}
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder={`Write your Comment for #  ${newsName}`}
                    type='text'
                    className="news__inputComment" 
                    />   
                    <button 
                    disabled={!newsId}
                    className="news__inputButton" 
                    type="submit"
                    onClick={sendNews} >
                    Send Comment
                    </button>
                </form>
            </div>
        </div>
    )
}
export default News

/*
*/ 